<template>
<div class="w-full min-h-screen flex flex-col bg-background overflow-hidden">
  <navbar/>
  <router-view></router-view>
</div>
</template>

<script>
import Navbar from './components/Navbar.vue'

export default {
  name: 'App',
  components: {
     Navbar
  }
}
</script>

<style>

/*font universal*/
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@400;700&display=swap');

/** fix aos bug overlapping dropdown */
.aos-fix[data-aos][data-aos].aos-animate {
    transform: unset;
}
#app{
  font-family: 'Comfortaa', cursive;
}
</style>
